export const formatCdn = (url?: string | null): string => {
    if (!url) return "";

    const isLocal = window.location.origin.includes("localhost");

    if (isLocal) {
        return url.replace("https://cdn.centralcart.com.br", "/cdn");
    }

    return url.startsWith("http")
        ? url
        : `https://cdn.centralcart.com.br${url}`;
};
